import { LocalStorageHelper } from "./LocalStorageHelper";

function create_UUID() {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

export const Common = {
    isEmpty: function (str) {
        return (str === null || str === undefined || str.length === 0);
    },

    //Aggregates data in an array by a valueField, uses a Primary and/or secondary category to aggregate against
    aggregateArrayByCategoryAndNumericValue: (data, categoryFields, valueField) => {
        const returnData = [];

        const primaryCategoryField = categoryFields[0];
        const secondaryCategoryField = categoryFields[1];

        const primaryCategories = [...new Set(data.map((x) => x[primaryCategoryField]))]; //get unique categories
        const secondaryCategories = [...new Set(data.map((x) => x[secondaryCategoryField ?? ""]))]; //get unique categories

        const filterOnSecondaryCategories = secondaryCategories?.length > 1;

        if (!filterOnSecondaryCategories) {
            primaryCategories.forEach((cat) => {
                const currentObj = data.find((x) => x[primaryCategoryField] === cat); //maintain current data structure

                currentObj[valueField] = data
                    .filter((obj) => obj[primaryCategoryField] === cat)
                    .map((obj) => parseFloat(obj[valueField]))
                    .reduce((p, c) => p + c, 0);

                returnData.push(currentObj);
            });
        }
        else {
            secondaryCategories.forEach((secondaryCat) => {
                primaryCategories.forEach((cat) => {
                    const currentObj = data.find((x) => x[primaryCategoryField] === cat && x[secondaryCategoryField] === secondaryCat); //maintain current data structure

                    if (!currentObj) {
                        return;
                    }

                    currentObj[valueField] = data
                        .filter((obj) => obj[primaryCategoryField] === cat)
                        .map((obj) => parseFloat(obj[valueField]))
                        .reduce((p, c) => p + c, 0);

                    returnData.push(currentObj);
                });
            });
        }

        return returnData;
    },

    xCorrelationId: function () {
        return create_UUID();
    },

    xRequestId: function () {
        return create_UUID();
    },

    generateUuid: function () {
        return create_UUID();
    },

    object_to_array: function (obj) {
        let result = [];
        if (obj && typeof obj !== 'string' && Object.keys(obj).length > 0) {
            Object.keys(obj).forEach(e => {
                if (obj[e] && obj[e].length > 0) {
                    obj[e].forEach((item) => {
                        result.push(item)
                    });
                }
            });
        }
        else if (typeof obj === 'string') {
            result.push(obj)
        }

        return result;
    },

    instanceOf: function (myVar, type) {
        let result = false;


        if (type === 'string' && (typeof myVar === type || myVar instanceof String)) {
            result = true;
        }
        else if (type === 'number' && (typeof myVar === type || myVar instanceof Number)) {
            result = true;
        }

        return result;
    },

    convertIdToDatePickerObject: function (idNumber) {
        let tempDate = new Date(idNumber.substring(0, 2), idNumber.substring(2, 4) - 1, idNumber.substring(4, 6));
        if (Math.abs(new Date(Date.now() - tempDate).getUTCFullYear() - 1970) > 99) {
            tempDate = new Date("20" + idNumber.substring(0, 2), idNumber.substring(2, 4) - 1, idNumber.substring(4, 6));
        }

        let id_date = tempDate.getDate();
        let id_month = tempDate.getMonth();
        let id_year = tempDate.getFullYear();

        let dateOfBirth = new Date(id_year, id_month, id_date, 0, 0, 0, 0);

        return dateOfBirth;
    },

    // getDefaultStateCodeGivenCountry: function (countryCode) {
    //     let defState = Provinces.
    //         filter(item => item.country === countryCode).
    //         map(returnval => ({
    //             value: returnval.value,
    //         }))[0];
    //     console.log('getDefaultStateCodeGivenCountry', defState.value);
    //     return defState.value;
    // },

    log() {
        if (process.env.REACT_APP_LOGGING_TO_CONSOLE !== "true") {
            return;
        }

        for (let i = 0; i < arguments.length; i++) {
            console.log(arguments[i]);
        }
    },

    getLanguageCode() {
        var path = window.location.pathname;
        var match = path.match(/(.*)\/mydstv/);
        return match != null && match.length > 0 ? match[1] : process.env.REACT_APP_DEFAULT_LANGUAGE;
    },

    parseUrl(url) {
        if (url == null) {
            return "";
        }

        url = url.replace("{origin}", window.location.origin);

        var languageCode = this.getLanguageCode();
        url = url.replace("{language}/", `${languageCode}/` || '');

        return url;
    },

    getRootPath() {
        var root = process.env.REACT_APP_ROOT_PATH;
        return this.parseUrl(root);
    },

    removeEmptyEntries(array) {
        return array?.filter(x => x != null && x.length > 0);
    },

    //Obsolete - use ModalAlert.alert() or ModalAlert.error()
    alert(message) {
        let modalWrapper = document.createElement("div");
        modalWrapper.className = "modal-wrapper";

        let el = document.createElement("div");
        el.className = "popup-modal";

        const removeAlert = (e) => document.body.removeChild(modalWrapper);

        let button = document.createElement("button");
        button.className = "close popup-modal-close";
        button.onclick = removeAlert;

        let span = document.createElement("span");
        span.className = "icon-close close"

        button.append(span);
        el.append(button);

        let p = document.createElement("p");
        p.innerHTML = message;

        let buttonOk = document.createElement("button");
        buttonOk.className = "btn rounded-pill btn-outline-black card-text font-bold mx-sm-3 cust-mt-2 mx-1 mx-sm-0"
        buttonOk.innerHTML = "OK";
        buttonOk.onclick = removeAlert;

        el.append(p);
        el.append(buttonOk);

        modalWrapper.append(el);

        document.body.append(modalWrapper);
    },

    isValueSet(value) {
        return value != null && Object.keys(value).length > 0;
    },

    pageTitle(title) {
        return `MyDStv Business ${title}`;
    },

    currencyString(value, currencyCode) {
        let localeCode = Common.getLanguageCode();
        return value.toLocaleString(localeCode, { style: "currency", currency: currencyCode });
    },

    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[[\]]/g, '\\$&');

        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        const results = regex.exec(url);

        if (!results) {
            return null;
        }

        if (!results[2]) {
            return '';
        }

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}

export const userPermissionsCollection = {
    balance: "1",
    statements: "2",
    clearError: "4",
    changePackage: "8",
    linkPackage: "16",
    disconnectPackage: "32",
    addUsers: "512",
    authorizations: "1024",
    updatePayment: "2048"
}

export const currencyCodes = {
    za: "ZAR",
    zaf: "ZAR",
    ng: "NGN",
    ke: "KES"
}

export const PageState = {
    Initial: 1,
    Processing: 2,
    Successful: 3,
    Error: 4
}

String.prototype.toTitleCase = function () {
    return this.toString().toLowerCase().replace(/(^|\s)\S/g, function (t) { return t.toUpperCase() });
}

export function _log() {
    for (let i = 0; i < arguments.length; i++) {
        var argument = arguments[i];
        LocalStorageHelper.log(argument);
        Common.log(argument);
    }
}

export const HttpStatus = {
    Ok: 200,
    Created: 201
};


export default { Common, currencyCodes, PageState, HttpStatus, _log }
